import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import AnimateHeight from 'react-animate-height'

import Panel from '../../UniformComponents/Panel'
import DistributeEmptyState from '../../UniformComponents/DistributeEmptyState'
import SearchLayout from '../Layouts/Search'
import DataTable from '../DataTable'
import Typography from '../../UniformComponents/Typography'
import Anchor from '../../UniformComponents/Anchor'
import Tooltip from '../../UniformComponents/Tooltip'
import Checkbox from '../form/Checkbox'
import Button from '../../UniformComponents/Button'
import { PageSwitchTab, tabOptions } from '../PageSwitchTab'
import TemplateSearchStore from './TemplateSearchStore'
import CreateEmailTemplateModal from './CreateEmailTemplateModal'
import TestEmailModal from '../Distribute/EmailBuilder/TestEmailModal'
import DeleteModal from '../../UniformComponents/DeleteModal'

@observer
class EmailTemplateSearch extends Component {
    constructor(props) {
        super(props)
        this.store = props.store
        this.templateSearchStore = new TemplateSearchStore(props.store, 'email')

        this.templateSearchStore.getTemplates()

        this.state = {
            showFilterPanel: (!!props?.hideFilterAccordion || window.innerWidth > 992),
            showGuideAccordion: !!props.showGuideAtInit,
        }

        this.setColumns()
    }

    componentDidMount() {
        window.addEventListener('resize', this.checkOverflow)
    }

    // find height diff of main-menu on overflow
    checkOverflow = () => {
        const { innerWidth } = window
        if (innerWidth > 992) {
            this.setState({ showFilterPanel: true })
        } else this.setState({ showFilterPanel: !!this.props.hideFilterAccordion || false })
    }

    toggleFilterPanel = () => {
        if (window.innerWidth > 992) return

        this.setState((prevState) => ({
            showFilterPanel: !prevState.showFilterPanel,
        }))
    }

    toggleGuide = () => {
        this.setState((prevState) => ({
            showGuideAccordion: !prevState.showGuideAccordion
        }))
    }

    renderPageTitle = (pageTitle, showFilterPanel, store) => (
        <div className="heading">
            <div
                className="heading"
                style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
                onClick={(e) => {
                   this.toggleFilterPanel()
                }}
            >
                <h3>{pageTitle}</h3>

                <Fragment>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <i className="filter-icon fa-regular fa-bars-filter" />
                        <p className="filter-text">{i18n.t('report_filters')}</p>
                        <i className={`panel-toggle-icon fa-regular ${showFilterPanel ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
                    </div>
                </Fragment>
            </div>

            {pageTitle === 'Questions' && store && (
                <div style={{ minHeight: 20, width: '100%' }}>
                    <DebugControl store={store} />
                </div>
            )}
        </div>
    )

    renderGuideAccordion = (showGuideAccordion, renderGuide) => (
        <Fragment>
            <hr className="heading-divider" />
            <div className="guide-accordion">
                <div
                    className="header"
                    onClick={this.toggleGuide}
                >
                    <i className="fa-solid fa-circle-info" />
                    <p>{i18n.t('preview.infoTitle')}</p>
                    <i className={`fa-light ${showGuideAccordion ? 'fa-square-chevron-up' : 'fa-square-chevron-down'}`} />
                </div>
                <AnimateHeight
                    className="guide-content"
                    duration={250}
                    height={showGuideAccordion ? 'auto' : 0}
                >
                    <hr className="divider" />
                    {renderGuide()}
                </AnimateHeight>
            </div>
        </Fragment>
    )

    setColumns = () => {
        const { templateSearchStore } = this
        this.columns = [
            {
                name: i18n.t('templates.templateName'),
                key: 'subject',
                cellClass: 'bold'
            },
            {
                name: '',
                key: 'id',
                dataTransform: (value) => (
                    <div className="survey-btn-wrapper">
                        <Anchor
                            cssClass="icon-link-btn"
                            onClick={() => templateSearchStore.showCreateTemplateEmailModal(value)}
                        >
                            <Tooltip
                                text={i18n.t('templates.edit')}
                                direction="bottom"
                            />
                            <i className="fa-light fa-edit" />
                        </Anchor>
                        <Anchor
                            cssClass="icon-link-btn"
                            onClick={() => templateSearchStore.showDeleteTemplateModal(value)}
                        >
                            <Tooltip
                                text={i18n.t('templates.delete')}
                                direction="bottom"
                            />
                            <i className="fa-light fa-circle-xmark" />
                        </Anchor>
                    </div>
                ),
            },
        ]
    }

    renderGuide = () => (
        <div dangerouslySetInnerHTML={{
            __html: i18n.t('templates.introText'),
        }}
        />
    )

    renderTablePanel = () => {
        const { templateSearchStore } = this
        return (
            <DataTable
                store={templateSearchStore}
                inMemory
                dataSet={templateSearchStore.filteredList || []}
                columns={this.columns}
            />
        )
    }

    renderFilterOptions = () => {
        const { templateSearchStore } = this
        return (
            <Fragment>
                <br />

                <Button
                    cssClass="add-button primary regular"
                    onClick={() => templateSearchStore.showCreateTemplateEmailModal()}
                    icon="fa-light fa-circle-plus"
                    label={i18n.t('templates.newEmail')}
                />

                {templateSearchStore.industriesFilterOptions.length
                    ? (
                        <fieldset className="filter">
                            <Typography type="b">
                                {i18n.t('industry')}
                            </Typography>

                            <br />

                            <br />

                            {templateSearchStore.industriesFilterOptions.map((opt) => (
                                <Checkbox
                                    name={opt.value}
                                    label={opt.label}
                                    onBlur={templateSearchStore.changeIndustryFilter}
                                    checked={templateSearchStore.industryFilter.includes(opt.value)}
                                />
                            ))}
                        </fieldset>
                    ) : null}


                {templateSearchStore.productTypeFilterOptions.length
                    ? (
                        <fieldset className="filter">
                            <Typography type="b">
                                {i18n.t('templates.eventType')}
                            </Typography>

                            <br />

                            <br />

                            {templateSearchStore.productTypeFilterOptions.map((opt) => (
                                <Checkbox
                                    name={opt.value}
                                    label={opt.label}
                                    onBlur={templateSearchStore.changeProductFilter}
                                    checked={templateSearchStore.productFilter.includes(opt.value)}
                                />
                            ))}
                        </fieldset>
                    ) : null}
                
                {templateSearchStore.surveyTypeFilterOptions.length
                    ? (
                        <fieldset className="filter">
                            <Typography type="b">
                                {i18n.t('templates.surveyType')}
                            </Typography>

                            <br />

                            <br />

                            {templateSearchStore.surveyTypeFilterOptions.map((opt) => (
                                <Checkbox
                                    name={opt.value}
                                    label={opt.label}
                                    onBlur={templateSearchStore.changeSurveyFilter}
                                    checked={templateSearchStore.surveyFilter.includes(opt.value)}
                                />
                            ))}
                        </fieldset>
                    ) : null}
                
                {templateSearchStore.respondentTypeFilterOptions.length
                    ? (
                        <fieldset className="filter">
                            <Typography type="b">
                                {i18n.t('templates.respondentType')}
                            </Typography>

                            <br />

                            <br />

                            {templateSearchStore.respondentTypeFilterOptions.map((opt) => (
                                <Checkbox
                                    name={opt.value}
                                    label={opt.label}
                                    onBlur={templateSearchStore.changeRespondentFilter}
                                    checked={templateSearchStore.respondentFilter.includes(opt.value)}
                                />
                            ))}
                        </fieldset>
                    ) : null}
            </Fragment>
        )
    }

    renderButtons = () => {
        const { store, location, history } = this.props
        return process.env.NEW_TEMPLATING ?
            (
                <PageSwitchTab
                    userRole={store.userData.role}
                    location={location}
                    history={history}
                    tabOptions={tabOptions.templates}
                />
            ) : null
    }

    render() {
        const { templateSearchStore: { templateList, showCreateTemplateEmailModal } } = this
        const { store } = this.props
        return (
            <div>
                 {!templateList.length
                    ? (
                        <Fragment>
                            <div className="search-container">
                                <div className="left-container">
                                    <Panel cssClass="filter-panel overflow-visible no-min-height">
                                        {this.renderPageTitle(i18n.t('templates.title'), this.state.showFilterPanel, store)}
                                        {this.renderGuideAccordion(this.state.showGuideAccordion, this.renderGuide)}
                                        <AnimateHeight
                                            className="filter-wrapper"
                                            duration={250}
                                            height={this.state.showFilterPanel ? 'auto' : 0}
                                            contentClassName="filter-content"
                                        >
                                            {this.renderFilterOptions()}
                                        </AnimateHeight>
                                    </Panel>
                                </div>

                                <div className="right-container">
                                    <Panel cssClass="search-panel">
                                        <div className="search-panel-right">
                                            {this.renderButtons()}
                                        </div>
                                    </Panel>

                                    <DistributeEmptyState
                                        title={i18n.t('templates.emptyEmailStateTitle')}
                                        subtext={i18n.t('templates.emptyEmailStateSubtext')}
                                        icon="fal fa-envelopes"
                                        ctaText={i18n.t('templates.emptyEmailStateCTA')}
                                        ctaIcon='fal fa-envelopes' 
                                        onClick={() => showCreateTemplateEmailModal()}
                                    />
                                </div>  
                            </div>
                        </Fragment>
                    )
                    : (
                        <SearchLayout
                            pageTitle={i18n.t('templates.title')}
                            renderFilterOptions={this.renderFilterOptions}
                            renderTablePanel={this.renderTablePanel}
                            renderGuide={this.renderGuide}
                            renderButtons={this.renderButtons}
                            searchStore={this.templateSearchStore}
                        />
                    )}

                <CreateEmailTemplateModal store={this.store} templateSearchStore={this.templateSearchStore} />
                <DeleteModal
                    show={this.templateSearchStore.deleteEmailTemplateModalVisible}
                    onClose={this.templateSearchStore.closeDeleteTemplateModal}
                    onDelete={this.templateSearchStore.deleteEmailTemplate}
                    yesLabel={i18n.t('templates.delete.email.yesLabel')}
                    headerText={i18n.t('templates.delete.email.title')}
                    content={i18n.t('templates.delete.email.description')}
                    noLabel={i18n.t('cancel')}
                />

                <TestEmailModal distributeStore={this.templateSearchStore} />
            </div>
        )
    }
}

export default EmailTemplateSearch
